import { categoryReportKeysToIgnore } from '../report-category-sales/report-category-sales-list/reportCategorySales.consts';
import { CUSTOMERS_REPORT_COLUMNS_KEY } from '../report-customers-sales/report-customers-sales-list/reportCustomersSalesList.consts';
import { ORDER_INCOME_BY_CUSTOMER_REPORT_COLUMNS_KEY } from '../report-order-income-by-customer-by-order/report-order-income-by-customer-by-order-list/reportOrderIncomeByCustomerByOrderList.consts';
import { ordersIncomeReportKeysToIgnore } from '../report-order-income/report-order-income-list/reportOrderIncomeColumns.consts';
import { ordersReportKeysToIgnore } from '../report-order-sales/report-order-sales-list/reportOrderSalesColumns.consts';
import { PERIOD_REPORT_COLUMNS_KEY } from '../report-period-sales/report-period-sales-list/reportPeriodSales.consts';
import { productSalesKeysToIgnore } from '../report-product-sales/report-product-sales-list/reportProductSalesList.consts';
import { REPRESENTATIVE_SALES_REPORT_COLUMNS_KEY } from '../report-representative-sales/report-representative-sales-list/reportRepresentativeSalesColumns.consts';
import { SALES_COLLECTION_REPORT_COLUMNS_KEY } from '../report-sales-collection/report-sales-collection-list/reportSalesCollectionColumns.consts';
import { SALES_TARGETS_SALES_REPORT_COLUMNS_KEY } from '../report-sales-target-sales-rep/report-sales-target-sales-rep-list/reportSalesTargetSalesRepColumns.consts';

export const allKeysToIgnoreInReportsToAvoidReload = [
  PERIOD_REPORT_COLUMNS_KEY,
  CUSTOMERS_REPORT_COLUMNS_KEY,
  SALES_COLLECTION_REPORT_COLUMNS_KEY,
  SALES_TARGETS_SALES_REPORT_COLUMNS_KEY,
  REPRESENTATIVE_SALES_REPORT_COLUMNS_KEY,
  ORDER_INCOME_BY_CUSTOMER_REPORT_COLUMNS_KEY,
  ...ordersReportKeysToIgnore,
  ...productSalesKeysToIgnore,
  ...categoryReportKeysToIgnore,
  ...ordersIncomeReportKeysToIgnore,
];

export const TOOLTIP_FONT_WEIGHT = 600;

export const OUR_BRAND_NAME = 'teceo';
